<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="产品管理" name="list">
				<div class="content-box" v-if="activeName == 'list'">
					<div class="operator">
						<div class="operator-col">
							<classify-input v-model="filterClassify" size="mini"></classify-input>
						</div>
						<div class="operator-col">
							<brand-input v-model="filterBrand"></brand-input>
						</div>
						<div class="operator-col">
							<season-input v-model="filterSeason"></season-input>
						</div>
						<div class="operator-col">
							<el-input
									size="mini"
									v-model="filterTableSearch"
									placeholder="商品名"
									suffix-icon="el-icon-search"
									clearable
							></el-input>
						</div>
						<div class="operator-col">
							<el-button
									size="mini"
									type="primary"
									@click="handleCreate()"
									v-loading="loadings.create"
							>新建</el-button
							>
						</div>
					</div>
					<div class="operator">
						<div class="operator-col">
							<bool-filter
								size="mini"
								v-model="filterIsPreSale.value"
								suffix-icon="el-icon-search"
								clearable
								data-model-name="Product_color"
								field="is_pre_sale"
								field-name="预售"
							></bool-filter>
						</div>
            <div class="operator-col">
              <bool-filter
                  size="mini"
                  v-model="filterIsAmount.value"
                  suffix-icon="el-icon-search"
                  clearable
                  data-model-name="Product_color"
                  field="amount"
                  field-name="有库存"
              ></bool-filter>
            </div>
            <div class="operator-col">
              <bool-filter
                  size="mini"
                  v-model="filterIsStar.value"
                  suffix-icon="el-icon-search"
                  clearable
                  data-model-name="Product_color"
                  field="is_star"
                  field-name="星标"
              ></bool-filter>
            </div>
						<div class="operator-col">
							<bool-filter
									size="mini"
									v-model="filterIsSpecial.value"
									suffix-icon="el-icon-search"
									clearable
									data-model-name="Product_color"
									field="is_special"
									field-name="特价"
							></bool-filter>
						</div>
<!--            <div class="operator-col">-->
<!--              <el-button size="mini" type="primary" @click="updateRate()">更新折扣率</el-button>-->
<!--            </div>-->
            <div class="operator-col" v-if="is_ningbo == 1">
              <el-button size="mini" type="primary" @click="FetchAdminSpu()">全量推送SPU到长沙和成都后台</el-button>
            </div>
					</div>
          <div class="operator">
            <div class="operator-col">
              <el-span>零 销 售：</el-span>
              <el-radio-group v-model="filterDateSlot" size="small">
                <el-radio-button label="1w">一周</el-radio-button>
                <el-radio-button label="2w">两周</el-radio-button>
                <el-radio-button label="1m">一个月</el-radio-button>
                <el-radio-button label="2m">两个月</el-radio-button>
                <el-radio-button label="3m">一个季度</el-radio-button>
                <el-radio-button label="all">全部</el-radio-button>
              </el-radio-group>
            </div>
            <div class="operator-col">
              <el-button size="mini" type="primary" @click="cancelfilterDateSlot()">取消</el-button>
            </div>
          </div>

          <div class="input-div">
            <span class="input-span">零售价折扣率（国内专柜价为基准）：</span>
            <el-input v-model="sale" size="mini" @change="check(sale)" placeholder="请输入零售价折扣率"></el-input>
          </div>
          <div class="input-div">
            <span class="input-span">代理价折扣率（代理价为基准）：</span>
            <el-input v-model="agent" size="mini"  @change="check(agent)" placeholder="请输入代理价折扣率"></el-input>
          </div>
          <div class="input-div">
            <span class="input-span">高级代理价折扣率（高级代理价为基准）：</span>
            <el-input v-model="senior_agent" size="mini"  @change="check(senior_agent)" placeholder="请输入高级代理价折扣率"></el-input>
          </div>
					<div class="operator">
						<div class="operator-col" v-if="userPrivilegeMapping[60]">
							<el-button size="mini" type="primary" :disabled="btnChangeEnable" @click="pushToIM() ">全量推送到IntraMirror</el-button>
						</div>
						<div class="operator-col" v-if="userPrivilegeMapping[60]">
							<el-button size="mini" type="primary" :disabled="btnChangeEnable" @click="syncPrice() ">代理价同步到高级代理价</el-button>
						</div>
					</div>
					<curd-table
						ref="listTable"
						:data-model="editorDataModel"
						:fields="tableFields"
						:expand-fields="expandFields"
						:has-delete="false"
						:kv-filter="kvFilter"
						:search-filter="filterTableSearch"
            :is-selectable="true"
            :batch-ops="[
                {key:'doHasPrice1',name:'零售价格设置'},
                {key:'doHasPrice3',name:'代理价格设置'},
                {key:'doHasPrice4',name:'高级代理价格设置'},
                {key:'doHasSpu',name:'同步SPU到宁波后台'},
                {key:'doHasStar',name:'设置星标'},
                {key:'doHasNoStar',name:'取消星标'},
                {key:'doHasPushIm',name:'同步到IM'},

            ]"
            @click-batch-op="handleClickBatchOp"
					>
						<template slot="listOp" slot-scope="scope">
							<el-button
								type="text"
								size="mini"
								@click="handleEditThumb(scope.row._id)"
								>缩略图</el-button
							>
							<el-button type="text" size="mini" @click="handleEdit(scope.row._id)"
								>编辑</el-button
							>
							<el-button type="text" size="mini" @click="goCheckTx(scope.row._id)"
								>历史</el-button
							>
						</template>
					</curd-table>
				</div>
			</el-tab-pane>

			<el-tab-pane label="待上架" name="needInlist">
					<div class="operator">
						<div class="operator-col">
							<classify-input v-model="filterClassify" size="mini"></classify-input>
						</div>
						<div class="operator-col">
							<brand-input v-model="filterBrand"></brand-input>
						</div>
						<div class="operator-col">
							<season-input v-model="filterSeason"></season-input>
						</div>
						<div class="operator-col">
							<el-input
								size="mini"
								v-model="filterTableSearch"
								placeholder="商品名"
								suffix-icon="el-icon-search"
								clearable
							></el-input>
						</div>
					</div>
					<curd-table
						ref="inListTable"
						data-model="Product_color"
						:fields="tableInlistFields"
						:has-delete="false"
						:kv-filter="kvFilter"
						:search-filter="filterTableSearch"
						list-url="spu/need_inlist"
					>
						<template slot="listOp" slot-scope="scope">
							<el-button
								type="text"
								size="mini"
								@click="handleEditQuota(scope.row._id)"
								>上架</el-button
							>
							<el-button type="text" size="mini" @click="handleEdit(scope.row._id)"
								>编辑</el-button
							>
						</template>
					</curd-table>
			</el-tab-pane>
			<el-tab-pane label="已上架" name="isInlist">
				<div class="content-box" v-if="activeName == 'isInlist'">
					<div class="operator">
						<div class="operator-col">
							<classify-input v-model="filterClassify" size="mini"></classify-input>
						</div>
						<div class="operator-col">
							<brand-input v-model="filterBrand"></brand-input>
						</div>
						<div class="operator-col">
							<season-input v-model="filterSeason"></season-input>
						</div>
						<div class="operator-col">
							<el-input
								size="mini"
								v-model="filterTableSearch"
								placeholder="商品名"
								suffix-icon="el-icon-search"
								clearable
							></el-input>
						</div>
					</div>
					<curd-table
						ref="isInListTable"
						data-model="Product_color"
						:fields="tableIsInlistFields"
						:has-delete="false"
						:kv-filter="kvFilter"
						:search-filter="filterTableSearch"
						list-url="spu/is_inlist"
					>
						<template slot="listOp" slot-scope="scope">
							<el-button
								type="text"
								size="mini"
								@click="handleEditQuota(scope.row._id)"
								>下架</el-button
							>
							<el-button type="text" size="mini" @click="handleEdit(scope.row._id)"
								>编辑</el-button
							>
						</template>
					</curd-table>
				</div>
			</el-tab-pane>
		</el-tabs>
		<editor
			:show.sync="editorVisible"
			data-model-name="Product_color"
			:record-id="editorId"
			:fields="editorFields"
			handler-url="spu/do_create"
			@change="handleEdited($event)"
		></editor>
		<editor
			:show.sync="editorColorVisible"
			data-model-name="Product_color"
			:record-id="editorColorId"
			:fields="editorColorFields"
			@change="refreshTable('listTable')"
		></editor>
		<editor
			:show.sync="editorQuotaVisible"
			data-model-name="Product_color"
			:record-id="editorId"
			:fields="editorQuotaFields"
			@change="refreshTables"
		></editor>
	</section>
</template>
<style>
.el-input{
  width: 200px;
}
.input-span{
  width: 200px;
}
.input-div{
  margin-top: 10px;
 }
</style>

<script>
import {mapState} from "vuex";

console.log("VUE_APP_IS_ADMIN：",process.env.VUE_APP_IS_ADMIN)
console.log("VUE_APP_IS_NINGBO：",process.env.VUE_APP_IS_NINGBO)
console.log("VUE_APP_IS_STORE：",process.env.VUE_APP_IS_STORE)
console.log("VUE_APP_IS_CHANGSHA：",process.env.VUE_APP_IS_CHANGSHA)


import CurdPage from "@/mixins/CurdPage.js";
import TabPage from "@/mixins/TabPage.js";
import Filters from "@/mixins/Filters.js";
import FilterSeason from "@/mixins/Filter/FilterSeason.js";
import FilterClassify from "@/mixins/Filter/FilterClassify.js";
import { RenderPrice } from "@/mixinsApp/Render.js";
import axios from "axios";
import qs from "qs";

export default {
	mixins: [CurdPage, TabPage, Filters, FilterSeason, FilterClassify],

	data() {
		return {
      sale:'0.88',
      agent:'0.9',
      senior_agent:'0.9',
      is_admin:process.env.VUE_APP_IS_ADMIN,
      is_ningbo:process.env.VUE_APP_IS_NINGBO,
      is_store:process.env.VUE_APP_IS_STORE,
      is_changsha:process.env.VUE_APP_IS_CHANGSHA,

      btnChangeEnable:false,

			filterIsSpecial: { field: "is_special", value: null },
			filterIsPreSale: { field: "is_pre_sale", value: null },
			filterIsAmount: { field: "amount", value: null },
			filterIsStar: { field: "is_star", value: null },
			editorDataModel: "Product_color",
      filterDateSlot : '',
			tableFields: [
				// {
				// 	name:"_id",
				// 	show_name:"产品编号",
				// 	width: "180px",
				// },
        {
          name:"is_star",
          sortable: "custom",
          render: (info) => {
            let str = info.is_star
            if (str == 0) {
              str = ""
            }else {
              str = "<div style='color: #0e0e0e;font-size: 18px'>★</div>"
            }
            return str;
          }
        },
				{
					name: "brand_show_id",
					width: "180px",
					needThumb: "thumb_img",

					params: {
						multiHidden: false,
					},
				},
        {
          name: "discount_rate",
          sortable: "custom",
          render: (info) => {
            let str = info.discount_rate
            if (str == 0) {
              str = "-"
            }
            return str;
          }
        },
        {
          name: "agent_discount_rate",
          sortable: "custom",
          render: (info) => {
            let str = info.agent_discount_rate
            if (str == 0) {
              str = "-"
            }
            return str;
          }
        },
				{
					name: "color_code",
				},
				{
					name: "brand",
					minWidth: "120px",
				},

				{
					name: "name",
					params: {
						multiHidden: false,
					},
					width: "160px",
				},
				{
					name: "color_name",
					// render: info => {
					// 	return `${info.color_name} / ${info.color_code} `;
					// }
				},
				{
					name: "is_listing",
					width: "120px",
					render: (info) => {
						let str = "";
						if (info.is_pre_sale) {
							str +=
								"<span class='el-tag el-tag--success el-tag--mini el-tag--light'>预售中</span><br/>";
						}
						if (info.self_quota != 0) {
							str += "LESMO:" + info.self_quota + ";<br/> ";
						}
						if (info.third_quota) {
							str += "IM:" + info.third_quota + ";<br/>";
						}
						if (info.third_quota_2ccm) {
							str += "2CCM:" + info.third_quota_2ccm + ";<br/>";
						}
						if (info.third_quota_buyer) {
							str += "Buyer:" + info.third_quota_buyer + ";<br/>";
						}
						if (str == "") {
							str = "否";
						}
						return str;
					},
				},
				{
					name: "amount",
					sortable: "custom",
					params: {
						isRight: true,
						isBold: true,
						isZeroSlash: true,
					},
					render: (info) => {
						let str = `<div class="text-right"><span class="text-semi font-black">`;
						if (info.is_pre_sale) {
							str += (info.amount_pre || "-") + "(预售)";
						} else {
							str += info.amount || "-";
						}
						str += "</span></div>";
						return str;
					},
				},
				{
					name: "cost_per",
					sortable: "custom",
					privilege: [59],
					params: {
						isRight: true,
						prefix: "",
					},
				},
				{
					name: "credit_ratio",
					params: {
						isRight: true,
						prefix: "",
					},
				},
				{
					name: "price_0",
					params: {
						isRight: true,
						prefix: "",
					},
				},
        {
          name: "price_6",
          sortable: "custom",
          params: {
            isRight: true,
            prefix: "",
          },
          render: (info) => {
            return RenderPrice(info, "price_6");
          },
        },
				{
					name: "price_1",
					sortable: "custom",
					params: {
						isRight: true,
						prefix: "",
					},
					render: (info) => {
						return RenderPrice(info, "price_1");
					},
				},
				{
					name: "price_2",
					sortable: "custom",
					params: {
						isRight: true,
						prefix: "",
					},
					render: (info) => {
						return RenderPrice(info, "price_2");
					},
				},
				{
					name: "price_3",
					sortable: "custom",
					params: {
						isRight: true,
						prefix: "",
					},
					render: (info) => {
						return RenderPrice(info, "price_3");
					},
          privilege: [13],
				},
				{
					name: "price_4",
					sortable: "custom",
					params: {
						isRight: true,
						prefix: "",
					},
					render: (info) => {
						return RenderPrice(info, "price_4");
					},
					privilege: [13],
				},
				{
					name: "price_in_active",
					sortable: "custom",
					params: {
						isRight: true,
						prefix: "",
					},
					privilege: [13],
				},
				{
					name: "distribution_mainland_type",
				},
				{
					name: "distribution_hongkong_type",
				},
				{
					name: "distribution_oversea_type",
				},
        {
          name:"is_special",
          sortable: "custom",
        },
        {
          name:"updated_at",
          sortable: "custom",
        },
			],
			tableInlistFields: [
				{
					name: "brand",
					minWidth: "120px",
				},
				{
					name: "brand_show_id",
					width: "180px",
					needThumb: "thumb_img",

					params: {
						multiHidden: false,
					},
				},
				{
					name: "color_code",
				},
				{
					name: "season",
				},
				{
					name: "name",
					params: {
						multiHidden: false,
					},
					width: "160px",
				},
				{
					name: "color_name",
					render: (info) => {
						return `${info.color_name} / ${info.color_code} `;
					},
				},
				{
					name: "amount",
					sortable: "custom",
					params: {
						isRight: true,
						isBold: true,
						isZeroSlash: true,
					},
				},
				{
					name: "primary_imgs",
					params: {
						isBreif: true,
					},
				},
				{
					name: "price_0",
					sortable: "custom",
				},
        {
          name: "price_6",
          sortable: "custom",
          params: {
            isRight: true,
            prefix: "",
          },
          render: (info) => {
            return RenderPrice(info, "price_6");
          },
        },
				{
					name: "price_1",
					sortable: "custom",
					params: {
						isRight: true,
						prefix: "",
					},
					render: (info) => {
						return RenderPrice(info, "price_1");
					},
				},
				{
					name: "price_2",
					sortable: "custom",
					params: {
						isRight: true,
						prefix: "",
					},
					render: (info) => {
						return RenderPrice(info, "price_2");
					},
				},
				{
					name: "price_3",
					sortable: "custom",
					params: {
						isRight: true,
						prefix: "",
					},
					render: (info) => {
						return RenderPrice(info, "price_3");
					},
				},
				{
					name: "price_4",
					sortable: "custom",
					params: {
						isRight: true,
						prefix: "",
					},
					render: (info) => {
						return RenderPrice(info, "price_4");
					},
				},
				{
					name: "distribution_mainland_type",
				},
				{
					name: "distribution_hongkong_type",
				},
				{
					name: "distribution_oversea_type",
				},

				// {
				// 	name: "price_5",
				// 	sortable: "custom",
				// 	params: {
				// 		isRight: true,
				// 		prefix: "",
				// 	},
				// 	render: info => {
				// 		return RenderPrice(info, "price_5");
				// 	},
				// },
			],
			tableIsInlistFields: [
				{
					name: "brand",
					minWidth: "120px",
				},
				{
					name: "brand_show_id",
					width: "180px",
					needThumb: "thumb_img",

					params: {
						multiHidden: false,
					},
				},
				{
					name: "season",
				},
				{
					name: "name",
					params: {
						multiHidden: false,
					},
					width: "160px",
				},
				{
					name: "color_name",
					render: (info) => {
						return `${info.color_name} / ${info.color_code} `;
					},
				},
				{
					name: "primary_imgs",
					params: {
						isBreif: true,
					},
				},
				{
					name: "amount",
					sortable: "custom",
					params: {
						isRight: true,
						isBold: true,
						isZeroSlash: true,
					},
				},

				{
					name: "self_quota",
					width: "120px",
					render: (info) => {
						let str = "";
						if (info.self_quota != 0) {
							str += "LESMO:" + info.self_quota + ";<br/> ";
						}
						if (info.third_quota) {
							str += "IM:" + info.third_quota + ";<br/>";
						}
						if (info.third_quota_2ccm) {
							str += "2CCM:" + info.third_quota_2ccm + ";<br/>";
						}
						if (info.third_quota_buyer) {
							str += "Buyer:" + info.third_quota_buyer + ";<br/>";
						}
						if (str == "") {
							str = "否";
						}
						return str;
					},
				},
				{
					name: "price_0",
					sortable: "custom",
				},
        {
          name: "price_6",
          sortable: "custom",
          params: {
            isRight: true,
            prefix: "",
          },
          render: (info) => {
            return RenderPrice(info, "price_6");
          },
        },
				{
					name: "price_1",
					sortable: "custom",
					params: {
						isRight: true,
						prefix: "",
					},
					render: (info) => {
						return RenderPrice(info, "price_1");
					},
				},
				{
					name: "price_2",
					sortable: "custom",
					params: {
						isRight: true,
						prefix: "",
					},
					render: (info) => {
						return RenderPrice(info, "price_2");
					},
				},
				{
					name: "price_3",
					sortable: "custom",
					params: {
						isRight: true,
						prefix: "",
					},
					render: (info) => {
						return RenderPrice(info, "price_3");
					},
				},
				{
					name: "price_4",
					sortable: "custom",
					params: {
						isRight: true,
						prefix: "",
					},
					render: (info) => {
						return RenderPrice(info, "price_4");
					},
				},
				{
					name: "price_5",
					sortable: "custom",
					params: {
						isRight: true,
						prefix: "",
					},
					render: (info) => {
						return RenderPrice(info, "price_5");
					},
				},
			],
			needInputTableFields: [
				{
					name: "brand_show_id",
					width: "180px",
					needThumb: "thumb_img",

					params: {
						multiHidden: false,
					},
				},
				{
					name: "brand",
					minWidth: "120px",
				},

				{
					name: "name",
					params: {
						multiHidden: false,
					},
					width: "160px",
				},
				{
					name: "colors",
				},
				{
					name: "models",
				},
			],
			expandFields: [
				{
					name: "classify",
					sortable: "custom",
				},
				{
					name: "season",
					sortable: "custom",
				},

				{
					name: "price_0",
					sortable: "custom",
				},
        {
          name: "price_6",
          sortable: "custom",
        },
				{
					name: "price_1",
					sortable: "custom",
				},
				{
					name: "price_2",
					sortable: "custom",
				},
				{
					name: "price_3",
					sortable: "custom",
				},
				{
					name: "price_4",
					sortable: "custom",
				},
				// {
				// 	name: "price_5",
				// 	sortable: "custom"
				// },
				{
					name: "thumb_img",
					sortable: false,
				},
				{
					name: "primary_imgs",
					sortable: false,
				},
			],
			editorFields: [
				{
					name: "brand_show_id",
					col: 6,
					rules: ["required"],
					width: "100%",
				},
				{
					name: "color_code",
					rules: ["required"],
					col: 6,
					width: "100%",
				},
				{
					name: "name",
					rules: ["required"],
					col: 6,
					width: "100%",
				},
				{
					name: "color_name",
					col: 6,
					width: "100%",
				},
				{
					name: "brand",
					rules: ["required"],
					col: 6,
				},
				{
					name: "classify",
					rules: ["required"],
					col: 6,
					params: {
						isLastLevel: true,
					},
				},

				{
					name: "season",
					col: 6,
					width: "100%",
				},
				{
					name: "price_0",
					col: 6,
					width: "100%",
				},
				{
					name: "cost_per",
					col: 6,
					width: "100%",
				},
				{
					name: "meta_gender",
					col: 6,
					width: "100%",
				},
				{
					name: "meta_age",
					col: 6,
					width: "100%",
				},
				{
					name: "thumb_img",
					col: 6,
					width: "100%",
				},
			],
			editorColorFields: [
				{
					name: "name",
					isOnlyShow: true,
				},
				{
					name: "color",
					isOnlyShow: true,
					col: 6,
				},
				{
					name: "brand_show_id",
					isOnlyShow: true,
					col: 6,
				},
				{
					name: "thumb_img",
					width: "100%",
				},
				{
					name: "primary_imgs",
					width: "100%",
				},
			],
			editorQuotaFields: [
				{
					name: "brand",
					isOnlyShow: true,
					col: 6,
				},
				{
					name: "name",
					isOnlyShow: true,
					col: 6,
				},
				{
					name: "color_name",
					isOnlyShow: true,
					col: 6,
				},
				{
					name: "color_code",
					isOnlyShow: true,
					col: 6,
				},
				{
					name: "brand_show_id",
					isOnlyShow: true,
					col: 6,
				},
				{
					name: "thumb_img",
					width: "100%",
				},
				{
					name: "primary_imgs",
					width: "100%",
				},
				{
					name: "self_quota",
					width: "100%",
					col: 6,
					tips: "-1 表示不限制",
				},
				{
					name: "third_quota",
					width: "100%",
					col: 6,
					tips: "-1 表示不限制",
				},
				{
					name: "third_quota_2ccm",
					width: "100%",
					col: 6,
					tips: "-1 表示不限制",
				},
				{
					name: "third_quota_buyer",
					width: "100%",
					col: 6,
					tips: "-1 表示不限制",
				},
				{
					name: "amount",
					width: "100%",
					isOnlyShow: true,
					col: 6,
				},
				{
					name: "is_sales",
					width: "100%",
					col: 6,
				},
				{
					name: "is_listing",
					width: "100%",
					col: 6,
				},
        {
          name: "is_star",
          width: "100%",
          col: 6,
        },
			],
			editorColorVisible: false,
			editorQuotaVisible: false,
			editorColorId: "",
      multipleSelection:[],
    };
	},
  computed: {
    ...mapState(["userPrivilegeMapping"])
  },
  methods: {
    FetchAdminSpu(){
      axios.post('/api/product/fetch_spu')
          .then((json) => {
            console.log(json.data)
            if(json.data.rstno == 1){

              this.$message({
                type: "success",
                message: '推送成功',
              });
            }else {
              this.$message({
                type: "error",
                message: json.data.data.msg,
              });
            }
          })
          .catch(function (error){
            console.log(error)
          })
    },
    updateRate(){
      axios.post('/api/product/updateRate')
          .then((json) => {
            console.log(json.data)
            if(json.data.rstno == 1){

              this.$message({
                type: "success",
                message: '更新成功',
              });
            }else {
              this.$message({
                type: "error",
                message: json.data.data.msg,
              });
            }
          })
          .catch(function (error){
            console.log(error)
          })
    },

    pushToIM(){
      this.btnChangeEnable = true;
      axios.post('/api/product/push_all_to_IM')
          .then((json) => {
            console.log(json.data)
            this.btnChangeEnable = false;
            if(json.data.rstno == 1){

              this.$message({
                type: "success",
                message: '同步成功',
              });
            }else {
              this.$message({
                type: "error",
                message: json.data.data.msg,
              });
            }
          })
          .catch(function (error){
            console.log(error)
          })
    },
		syncPrice(){
			this.btnChangeEnable = true;
			axios.post('/api/product/syncPrice')
					.then((json) => {
						console.log(json.data)
						this.btnChangeEnable = false;
						if(json.data.rstno == 1){
							this.$message({
								type: "success",
								message: json.data.data.msg,
							});
							this.refreshTables()
						}else {
							this.$message({
								type: "error",
								message: json.data.data.msg,
							});
						}
					})
					.catch(function (error){
						console.log(error)
					})
		},

    cancelfilterDateSlot(){
      this.filterDateSlot = '';
      this.$delete(this.kvFilter, 'zero');
      this.refreshTables()
    },

		refreshTables() {
			this.refreshTable("listTable");
			this.refreshTable("inListTable");
			this.refreshTable("isInListTable");
		},

    doHasPrice1(id){
      this.payIsIncome = true;
      this.payEditorId = id;
      this.payEditorVisible = true;
      console.log(id)
    },
    doHasPrice3(id){
      this.payIsIncome = true;
      this.payEditorId = id;
      this.payEditorVisible = true;
      console.log(id)
    },
    doHasPrice4(id){
      this.payIsIncome = true;
      this.payEditorId = id;
      this.payEditorVisible = true;
      console.log(id)
    },
    doHasSpu(id){
      this.payIsIncome = true;
      this.payEditorId = id;
      this.payEditorVisible = true;
      console.log(id)
    },
    doHasStar(id){
      this.payIsIncome = true;
      this.payEditorId = id;
      this.payEditorVisible = true;
      console.log(id)
    },
    doHasNoStar(id){
      this.payIsIncome = true;
      this.payEditorId = id;
      this.payEditorVisible = true;
      console.log(id)
    },
    doHasPushIm(id){
      this.payIsIncome = true;
      this.payEditorId = id;
      this.payEditorVisible = true;
      console.log(id)
    },
    check(value){
      let reg = /[^\d\.]/g;
      if (value && new RegExp(reg).test(value)) {
        this.$message({
          message: '请输入正确的折扣率',
          type: 'error'
        })
        return;
      }
    },

    handleBatch_doHasPrice1(checks)
    {
      console.log(this.sale)
      console.log(this.agent)
      this.batchConfirmInfo = {
        count: 0,
        recordIds: [],
      };

      const data = this.$refs["listTable"].tableData.filter((v, k) => {
        return checks[k];
      });
      data.forEach(v => {
        this.batchConfirmInfo.count++;
        this.batchConfirmInfo.recordIds.push(v._id);
      });

      console.log(this.batchConfirmInfo.recordIds)

      axios.post('/api/product/set_price1',qs.stringify({
        post:this.batchConfirmInfo.recordIds,
        sale:this.sale,
        agent:this.agent,
      }))
          .then((json) => {
            console.log(json.data)
            if(json.data.rstno == 1){
              // if(json.data.data.info > 0){
                this.$message({
                  type: "success",
                  message: "设置成功"+json.data.data.info+"条!",
                });
                this.loadings.main = false;
                this.refreshTable("listTable");
                this.refreshTable("inputListTable");
              // }else {
              //   this.$message({
              //     type: "error",
              //     message: "价格已设置!",
              //   });
              // }
            }else {
              this.$message({
                type: "error",
                message: json.data.data.msg,
              });
            }
          })
          .catch(function (error){
            console.log(error)
          })
    },
    handleBatch_doHasPrice3(checks)
    {
      console.log(this.sale)
      console.log(this.agent)
      this.batchConfirmInfo = {
        count: 0,
        recordIds: [],
      };

      const data = this.$refs["listTable"].tableData.filter((v, k) => {
        return checks[k];
      });
      data.forEach(v => {
        this.batchConfirmInfo.count++;
        this.batchConfirmInfo.recordIds.push(v._id);
      });

      console.log(this.batchConfirmInfo.recordIds)

      axios.post('/api/product/set_price3',qs.stringify({
        post:this.batchConfirmInfo.recordIds,
        sale:this.sale,
        agent:this.agent,
      }))
          .then((json) => {
            console.log(json.data)
            if(json.data.rstno == 1){
              // if(json.data.data.info > 0){
              this.$message({
                type: "success",
                message: "设置成功"+json.data.data.info+"条!",
              });
              this.loadings.main = false;
              this.refreshTable("listTable");
              this.refreshTable("inputListTable");
              // }else {
              //   this.$message({
              //     type: "error",
              //     message: "价格已设置!",
              //   });
              // }
            }else {
              this.$message({
                type: "error",
                message: json.data.data.msg,
              });
            }
          })
          .catch(function (error){
            console.log(error)
          })
    },
    handleBatch_doHasPrice4(checks)
    {
      console.log(this.senior_agent)
      this.batchConfirmInfo = {
        count: 0,
        recordIds: [],
      };

      const data = this.$refs["listTable"].tableData.filter((v, k) => {
        return checks[k];
      });
      data.forEach(v => {
        this.batchConfirmInfo.count++;
        this.batchConfirmInfo.recordIds.push(v._id);
      });

      console.log(this.batchConfirmInfo.recordIds)

      axios.post('/api/product/set_price4',qs.stringify({
        post:this.batchConfirmInfo.recordIds,
        senior_agent:this.senior_agent,
      }))
          .then((json) => {
            console.log(json.data)
            if(json.data.rstno == 1){
              // if(json.data.data.info > 0){
              this.$message({
                type: "success",
                message: "设置成功"+json.data.data.info+"条!",
              });
              this.loadings.main = false;
              this.refreshTable("listTable");
              this.refreshTable("inputListTable");
              // }else {
              //   this.$message({
              //     type: "error",
              //     message: "价格已设置!",
              //   });
              // }
            }else {
              this.$message({
                type: "error",
                message: json.data.data.msg,
              });
            }
          })
          .catch(function (error){
            console.log(error)
          })
    },

    handleBatch_doHasSpu(checks)
    {
      console.log(this.sale)
      console.log(this.agent)
      this.batchConfirmInfo = {
        count: 0,
        recordIds: [],
      };

      const data = this.$refs["listTable"].tableData.filter((v, k) => {
        return checks[k];
      });
      data.forEach(v => {
        this.batchConfirmInfo.count++;
        this.batchConfirmInfo.recordIds.push(v._id);
      });

      console.log(this.batchConfirmInfo.recordIds)

      axios.post('/api/product/push_spu',qs.stringify({
        post:this.batchConfirmInfo.recordIds,
      }))
          .then((json) => {
            console.log(json.data)
            if(json.data.rstno == 1){
              this.$message({
                type: "success",
                message: "数据同步成功",
              });
              this.refreshTable("listTable");
              this.refreshTable("inputListTable");

            }else {
              this.$message({
                type: "error",
                message: json.data.data.msg,
              });
            }
          })
          .catch(function (error){
            console.log(error)
          })
    },

    handleBatch_doHasStar(checks)
    {
      console.log(this.sale)
      console.log(this.agent)
      this.batchConfirmInfo = {
        count: 0,
        recordIds: [],
      };

      const data = this.$refs["listTable"].tableData.filter((v, k) => {
        return checks[k];
      });
      data.forEach(v => {
        this.batchConfirmInfo.count++;
        this.batchConfirmInfo.recordIds.push(v._id);
      });

      console.log(this.batchConfirmInfo.recordIds)

      axios.post('/api/product/set_star',qs.stringify({
        post:this.batchConfirmInfo.recordIds,
        sale:this.sale,
        agent:this.agent,
      }))
          .then((json) => {
            console.log(json.data)
            if(json.data.rstno == 1){
              // if(json.data.data.info > 0){
              this.$message({
                type: "success",
                message: "设置成功"+json.data.data.info+"条!",
              });
              this.loadings.main = false;
              this.refreshTable("listTable");
              this.refreshTable("inputListTable");
              // }else {
              //   this.$message({
              //     type: "error",
              //     message: "价格已设置!",
              //   });
              // }
            }else {
              this.$message({
                type: "error",
                message: json.data.data.msg,
              });
            }
          })
          .catch(function (error){
            console.log(error)
          })
    },

    handleBatch_doHasNoStar(checks)
    {
      console.log(this.sale)
      console.log(this.agent)
      this.batchConfirmInfo = {
        count: 0,
        recordIds: [],
      };

      const data = this.$refs["listTable"].tableData.filter((v, k) => {
        return checks[k];
      });
      data.forEach(v => {
        this.batchConfirmInfo.count++;
        this.batchConfirmInfo.recordIds.push(v._id);
      });

      console.log(this.batchConfirmInfo.recordIds)

      axios.post('/api/product/set_no_star',qs.stringify({
        post:this.batchConfirmInfo.recordIds,
        sale:this.sale,
        agent:this.agent,
      }))
          .then((json) => {
            console.log(json.data)
            if(json.data.rstno == 1){
              // if(json.data.data.info > 0){
              this.$message({
                type: "success",
                message: "设置成功"+json.data.data.info+"条!",
              });
              this.loadings.main = false;
              this.refreshTable("listTable");
              this.refreshTable("inputListTable");
              // }else {
              //   this.$message({
              //     type: "error",
              //     message: "价格已设置!",
              //   });
              // }
            }else {
              this.$message({
                type: "error",
                message: json.data.data.msg,
              });
            }
          })
          .catch(function (error){
            console.log(error)
          })
    },


    handleBatch_doHasPushIm(checks)
    {
      this.batchConfirmInfo = {
        count: 0,
        recordIds: [],
      };

      const data = this.$refs["listTable"].tableData.filter((v, k) => {
        return checks[k];
      });
      data.forEach(v => {
        this.batchConfirmInfo.count++;
        this.batchConfirmInfo.recordIds.push(v._id);
      });

      console.log(this.batchConfirmInfo.recordIds)

      axios.post('/api/product/push_im',qs.stringify({
        post:this.batchConfirmInfo.recordIds,
      }))
          .then((json) => {
            console.log(json.data)
            if(json.data.rstno == 1){
              // if(json.data.data.info > 0){
              this.$message({
                type: "success",
                message: "同步成功",
              });
              this.loadings.main = false;
              this.refreshTable("listTable");
              this.refreshTable("inputListTable");
            }else {
              this.$message({
                type: "error",
                message: json.data.data.msg,
              });
            }
          })
          .catch(function (error){
            console.log(error)
          })
    },

		handleDelete(id) {
			this.loadings.main = true;
			this.$confirm("将永久删除该条目, 是否继续?", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					const url = `/curd/do_delete/product_color/${id}`;

					this.$axios
						.post(url, { id: id })
						.then((json) => {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.loadings.main = false;
							this.refreshTable("listTable");
							this.refreshTable("inputListTable");
						})
						.catch((json) => {
							this.loadings.main = false;
							this.$message.error(json.data.msg);
						});
				})
				.catch(() => {
					this.loadings.main = false;

					this.$message({
						type: "info",
						message: "已取消删除",
					});
				});
		},
		handleEdit(id) {
			const { href } = this.$router.resolve({
				name: "Config-SPU-Edit",
				params: {
					id: id,
				},
			});
			window.open(href, "_blank");
		},
		handleEditThumb(id) {
			this.editorColorId = id;
			this.editorColorVisible = true;
		},
		handleEditQuota(id) {
			this.editorId = id;
			this.editorQuotaVisible = true;
		},
		handleEdited(data) {
			this.$router.push({
				name: "Config-SPU-Edit",
				params: {
					id: data._id,
				},
			});
		},
		goCheckTx(id) {
			const { href } = this.$router.resolve({
				name: "Config-SPU-Tx",
				params: {
					id: id,
				},
			});
			window.open(href, "_blank");
		},
	},
	watch: {
		"filterIsSpecial.value": {
			handler(newVal) {
				let val = this.filterIsSpecial;
				if (val.value != null && val.value !== "") {
					this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.value });
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true,
		},
		"filterIsPreSale.value": {
			handler(newVal) {
				let val = this.filterIsPreSale;
				if (val.value != null && val.value !== "") {
					this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.value });
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true,
		},
    "filterIsAmount.value": {
      handler(newVal) {
        let val = this.filterIsAmount;
        console.log(val)
        if (val.value == "1") {
          this.$set(this.kvFilter, val.field, { k: val.field, t: "int", lge:">=", v: 1 });
        } else if(val.value == "0") {
          this.$set(this.kvFilter, val.field, { k: val.field, t: "int", lge:"<", v: 1 });
        }else {
          this.$delete(this.kvFilter, val.field);
        }
      },
      immediate: true,
    },
    "filterIsStar.value": {
      handler(newVal) {
        let val = this.filterIsStar;
        if (val.value != null && val.value !== "") {
          this.$set(this.kvFilter, val.field, { k: val.field, t: "int", v: val.value });
        } else {
          this.$delete(this.kvFilter, val.field);
        }
      },
      immediate: true,
    },
    filterDateSlot() {
      this.$nextTick(() => {
        console.log(this.filterDateSlot)

        let val = this.filterDateSlot;
        if (val != null && val !== "") {
          this.$set(this.kvFilter, 'zero', { k: 'zero', t: "string", v: val });
        } else {
          this.$delete(this.kvFilter, val);
        }
        // this.refreshTables();
      });
    },
	},
};
</script>
